// THE MARKETING PIXEL LOADER (STORE-08; D-22, D-23, D-24; T-08A-39, T-08A-41; plan 08A-27). The
// server names each configured provider's ID and script URL; this controller defines the provider's
// queue here, in the bundle, and injects the vendor's script element. No inline script exists, so
// `script-src` admits only this origin and the configured vendors' fixed origins.
//
// With the consent banner on, nothing loads until the visitor's cookie says «موافق», now or on an
// earlier visit; the banner's `storefront-consent:granted` starts it. With it off, it loads at once.
import { Controller } from "@hotwired/stimulus"
import { GRANTED, readConsent } from "./consent_controller"

// Each provider's documented queue stub, written out rather than evaluated from a snippet.
const QUEUES = {
  meta(id) {
    if (!window.fbq) {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments)
        else fbq.queue.push(arguments)
      }
      Object.assign(fbq, { loaded: true, version: "2.0", queue: [] })
      fbq.push = fbq
      window.fbq = fbq
      window._fbq = window._fbq || fbq
    }
    window.fbq("init", id)
    window.fbq("track", "PageView")
  },

  ga4(id) {
    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
    window.gtag("js", new Date())
    window.gtag("config", id)
  },

  tiktok(id, src) {
    const ttq = (window.ttq = window.ttq || [])
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group",
      "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"]
    ttq.setAndDefer = (target, method) => {
      target[method] = function () { target.push([method].concat(Array.prototype.slice.call(arguments, 0))) }
    }
    ttq.methods.forEach((method) => ttq.setAndDefer(ttq, method))
    ttq.instance = (name) => {
      const instance = ttq._i[name] || []
      ttq.methods.forEach((method) => ttq.setAndDefer(instance, method))
      return instance
    }
    ttq._i = ttq._i || {}
    ttq._i[id] = []
    ttq._i[id]._u = src.split("?")[0]
    ttq._t = ttq._t || {}
    ttq._t[id] = Date.now()
    ttq._o = ttq._o || {}
    ttq._o[id] = {}
    ttq.page()
  },

  snap(id) {
    if (!window.snaptr) {
      const snaptr = function () {
        if (snaptr.handleRequest) snaptr.handleRequest.apply(snaptr, arguments)
        else snaptr.queue.push(arguments)
      }
      snaptr.queue = []
      window.snaptr = snaptr
    }
    window.snaptr("init", id, {})
    window.snaptr("track", "PAGE_VIEW")
  }
}

export default class extends Controller {
  static values = { pixels: Array, consentRequired: Boolean, cookie: String }

  connect() {
    if (!this.consentRequiredValue || readConsent(this.cookieValue) === GRANTED) this.load()
  }

  load() {
    if (this.loaded) return
    this.loaded = true
    this.pixelsValue.forEach(({ provider, id, src }) => {
      const queue = QUEUES[provider]
      if (!queue) return

      queue(id, src)
      const script = document.createElement("script")
      script.async = true
      script.src = src
      document.head.appendChild(script)
    })
  }
}
